// extracted by mini-css-extract-plugin
export default {"details":"_13BUhZAvPVbteQg6HvbS55","details__info-panel":"PMm7bgEDFoPR7I-lEeHoG","details__spec-container":"_3YMNqQdgFh_DzeAbm7ndkp"};